export const FINANCING_HIGHLIGHT_KEY = 'Financiering mogelijk bij aanbieder';
